import { DocumentItemList } from '../../components/document/DocumentItemList';
import { useFetchVehicleDocuments } from '../../hooks/useFetchVehicleDocuments';

type Props = {
  vehicleId: string;
};

export const VehicleDocuments = ({ vehicleId }: Props) => {
  const { data, isLoading } = useFetchVehicleDocuments(vehicleId);

  return <DocumentItemList isLoading={isLoading} documentItems={data?.items} vehicleId={vehicleId} />;
};
